// extracted by mini-css-extract-plugin
export default {"items":"regions-list_items__JDWdP"};